const colors = [
  {
    name: 'blue',
    bgs: [
      { color: '#fff', bg: '#232980' },
      { color: '#fff', bg: '#3b418e' },
      { color: '#fff', bg: '#54589c' },
      { color: '#fff', bg: '#6c70aa' },
      { bg: '#8588b9' },
      { bg: '#9da0c7' },
      { bg: '#b6b8d5' },
      { bg: '#cecfe3' },
    ],
  },
  {
    name: 'red',
    bgs: [
      { color: '#fff', bg: '#db1a1a' },
      { color: '#fff', bg: '#df3333' },
      { color: '#fff', bg: '#e34d4d' },
      { color: '#fff', bg: '#e76666' },
      { bg: '#eb8080' },
      { bg: '#ef9999' },
      { bg: '#f3b3b3' },
      { bg: '#f7cccc' },
    ],
  },
  {
    name: 'green',
    bgs: [
      { color: '#fff', bg: '#1b9627' },
      { color: '#fff', bg: '#35a13f' },
      { color: '#fff', bg: '#4ead57' },
      { color: '#fff', bg: '#67b96f' },
      { bg: '#81c587' },
      { bg: '#9ad09f' },
      { bg: '#b3dcb7' },
      { bg: '#cce8cf' },
    ],
  },
  {
    name: 'yellow',
    bgs: [
      { bg: '#f7c933' },
      { bg: '#f8cf49' },
      { bg: '#f9d560' },
      { bg: '#fadb77' },
      { bg: '#fbe18e' },
      { bg: '#fbe7a4' },
      { bg: '#fcedbb' },
      { bg: '#fdf3d2' },
    ],
  },
  {
    name: 'purple',
    bgs: [
      { color: '#fff', bg: '#7f1a9e' },
      { color: '#fff', bg: '#8d34a9' },
      { color: '#fff', bg: '#9c4db3' },
      { color: '#fff', bg: '#aa67be' },
      { bg: '#b880c9' },
      { bg: '#c699d4' },
      { bg: '#d4b3df' },
      { bg: '#e3cce9' },
    ],
  },
  {
    name: 'orange',
    bgs: [
      { bg: '#ef7e2c' },
      { bg: '#f18d43' },
      { bg: '#f29b5b' },
      { bg: '#f4a972' },
      { bg: '#f6b88a' },
      { bg: '#f8c6a1' },
      { bg: '#fad4b9' },
      { bg: '#fbe2d0' },
    ],
  },
  {
    name: 'gray',
    bgs: [
      { bg: '#8d8d8d' },
      { bg: '#999999' },
      { bg: '#a6a6a6' },
      { bg: '#b3b3b3' },
      { bg: '#C0C0C0' },
      { bg: '#cccccc' },
      { bg: '#d9d9d9' },
      { bg: '#e6e6e6' },
    ],
  },
];
export default colors;
